export default __webpack_public_path__ + "static/media/risk-evaluation.949f6434.pdf";